import React from 'react';

class FaqButtonServiceDesign extends React.Component {

    constructor(props) {
        super(props);
        this.DEFAULT_TIME_OUT_BEFORE_CONFIRMATION = 3000000;
        this.DEFAULT_TIME_OUT_AFTER_CONFIRMATION = 3600000;
        this.franchiseData = this.props.franchiseData;
        this.siteConfigData = this.props.siteConfigData;
        this.isSwapSite = this.props.isSwapSite;
        this.state = {
            booking: null,
            hash: null,
            paymentConfirmation: null,
            error: null,
            timeOutBeforeConfirmation: this.DEFAULT_TIME_OUT_BEFORE_CONFIRMATION, // milliseconds...
            timeOutAfterConfirmation: this.DEFAULT_TIME_OUT_AFTER_CONFIRMATION, // milliseconds...
            initialRemainingTime: 600000,
            showCountDownUnder: 10000,
            showModal: false,
            activeComponentInMain: 'verification',
            sessionExpired: false,
            remainingTimeFunction: null,
            faqButtons: []
        }
        this.faqButtonService();

    }
    
    faqButtonService = () => {
        let xhttp = new XMLHttpRequest();
        let helpURLClean = this.getStoreAttValue('HLP').replace('hc/en-us', '');
        let faqButtonServiceURI = helpURLClean + '/api/v2/help_center/en-us/categories.json';
        xhttp.open("GET", faqButtonServiceURI, true);
        xhttp.setRequestHeader("Accept", "application/json");
        xhttp.onreadystatechange = function() { 
            if (xhttp.readyState === 4 && xhttp.status === 200) {
                let response = JSON.parse(xhttp.response);
                this.setState({
                    faqButtons: response.categories
                });   
            }
            
        }.bind(this);
        xhttp.send();	  
   }
    getStoreAttValue = (attCode) => {
        let storeAttributeValue='';
        for(let i=0; i<this.props.siteConfigData.store.storeAttributes.length; i++){
            if(this.props.siteConfigData.store.storeAttributes[i].attributeCode===attCode){
                storeAttributeValue = this.props.siteConfigData.store.storeAttributes[i].attributeValue;
            }
        }
        return storeAttributeValue;
    }

    render = () => {
        return (
            <>
                {
                    this.state.faqButtons.map((category, index) => (
                        <a 
                            href={category.html_url} 
                            class='wth3-moreLinksContainer__faq-faqContainer-link wth3-link-btn' 
                            id={`cssSummaryFaqButton_${index}`} 
                            target='_blank' rel="noopener noreferrer"
                            onClick = {() => {this.props.CallTracker("BCSS Login", `${category.innerHTML}`, "")} }>
                            {category.name}
                        </a>

                    ))
                }
            </>
        );            
    }

}
export default FaqButtonServiceDesign;
